import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=660ef3ca"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"
import style0 from "./Welcome.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports